import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import {
  CompanyId,
  AssignTeamsRandomly$Request,
  DivisionRow,
  UserDto,
  UserCompanyDto,
  GoalWithProgress,
  GetAssignRandomTeamsFilters$Response,
  DivisionDto,
} from '../../../../services/api.types'
import { assignTeamsRandomly, getAssignRandomTeamsFilters } from '../../store/TeamManagementActions'
import {
  getTeamsLoading,
  getAssignRandomTeamsFilters as getAssignRandomTeamsFiltersSelector,
} from '../../store/TeamManagementSelectors'
import { IGlobalState } from '../../../../Root/store/appReducer'
import AssignTeamsRandomly from './AssignTeamsRandomly'
import { getUserGoals } from '../../../Activity/store/ActivitySelectors'

interface AssignTeamsRandomlyWrapperProps {
  open: boolean
  onClose: () => void
  companyId: CompanyId
  companyTeams: DivisionDto[]
  companyUsers: UserDto[]
  usersLoading: boolean
  userCompany: UserCompanyDto
}

interface AssignTeamsRandomlyDispatchProps {
  assignTeamsRandomly: (payload: AssignTeamsRandomly$Request) => void
  getAssignRandomTeamsFilters: (payload: {
    companyId: CompanyId
    includeUsersWithTeams: boolean
    goalId?: string
  }) => void
}

interface AssignTeamsRandomlyStateProps {
  loading: boolean
  filtersData: {
    loading: boolean
    data: GetAssignRandomTeamsFilters$Response | null
  }
}

const mapStateToProps = (state: IGlobalState) => ({
  loading: getTeamsLoading(state),
  filtersData: getAssignRandomTeamsFiltersSelector(state) || {
    loading: false,
    data: null,
  },
})

const mapDispatchToProps: AssignTeamsRandomlyDispatchProps = {
  assignTeamsRandomly,
  getAssignRandomTeamsFilters,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)((props: AssignTeamsRandomlyWrapperProps & AssignTeamsRandomlyDispatchProps & AssignTeamsRandomlyStateProps) => {
  const { assignTeamsRandomly, loading, getAssignRandomTeamsFilters, companyId, filtersData, ...rest } = props

  // Fetch initial filters data when dialog opens
  useEffect(() => {
    if (props.open) {
      getAssignRandomTeamsFilters({
        companyId,
        includeUsersWithTeams: false,
      })
    }
  }, [props.open, getAssignRandomTeamsFilters, companyId])

  const handleSubmit = (payload: AssignTeamsRandomly$Request) => {
    assignTeamsRandomly(payload)
  }

  const handleFiltersChange = (includeUsersWithTeams: boolean, goalId?: string) => {
    getAssignRandomTeamsFilters({
      companyId,
      includeUsersWithTeams,
      goalId,
    })
  }

  return (
    <AssignTeamsRandomly
      onSubmit={handleSubmit}
      loading={loading}
      filtersData={filtersData}
      onFiltersChange={handleFiltersChange}
      companyId={companyId}
      {...rest}
    />
  )
})
